import { registerPlugin } from '@capacitor/core';

const PlayIntegrity = registerPlugin('PlayIntegrity');

export default PlayIntegrity;